export default "__VITE_PUBLIC_ASSET__34e75bc6__"